import { ReactNode, useEffect, useMemo } from 'react';

import createSafeContext from '@paradigm/utils/createSafeContext';

import {
  PublicCounterpartiesService,
  createCounterpartiesService,
} from '#/unified-rfqs/services/counterparties';

const [useCounterpartiesService, CpsServiceCtxProvider] =
  createSafeContext<PublicCounterpartiesService>('CounterpartiesService');

export { useCounterpartiesService };

interface Props {
  readonly children: ReactNode;
}

export function CounterpartiesServiceProvider({ children }: Props) {
  const cpsService = useMemo(createCounterpartiesService, []);

  useEffect(() => {
    return () => {
      cpsService.teardown();
    };
  }, [cpsService]);

  return (
    <CpsServiceCtxProvider value={cpsService}>{children}</CpsServiceCtxProvider>
  );
}
